import React, { Component } from "react";
import { Link } from "react-router-dom";

import { UserIcon } from "components";

// Composant qui render une Card.
class Card extends Component {
  render() {
    const { content } = this.props;
    if (!content) return <></>;

    const link = { to: content.link || "/", onClick: (e) => !content.link && e.preventDefault() };

    const imgStyle = { style: { backgroundColor: "rgba(255,255,255,.85)" } };
    const img =
      typeof content.image === "function" ? (
        <Link className="image" {...imgStyle} {...link}>
          {content.image()}
        </Link>
      ) : (
        <Link
          className="image"
          style={{ backgroundImage: `url(${content.image})` }}
          {...link}
        ></Link>
      );

    return (
      <div className={"card " + (content.classes || "")}>
        <div className="card-header">
          {img}
          {content.users && (
            <div className="users-list">
              {content.users.map((u, i) => {
                if (content.users[0].visitor_name) {
                  return content.users[0].visitor_name;
                } else {
                  return <UserIcon key={i} user={u} link />;
                }
              })}
              {content.client && (
                <div className="client-wrap">
                  <UserIcon client user={content.client} link />
                </div>
              )}
            </div>
          )}
          {content.extraHeader && content.extraHeader}
        </div>

        <Link className="card-body" {...link}>
          <p className="title">{content.title}</p>
          <p className="descr">{content.descr}</p>
          {content.extraBody ? content.extraBody : <></>}
        </Link>

        {content.footer && <div className="card-footer"></div>}
      </div>
    );
  }
}

export default Card;
